<template>
  <common-dialog ref="dialog" width="500px" title="批量修改库存" :data="data" :form-rules="rules" :save-func="saveFunc"
    show-save-button @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="修改方式">
        <el-radio-group v-model="data.type">
          <el-radio :label="0">统一库存</el-radio>
          <el-radio :label="1">库存增加</el-radio>
          <el-radio :label="2">库存减少</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="数值" prop="stockNum">
        <el-input-number v-model="data.stockNum" :min="0" controls-position="right" />
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import goodsApi from '@/api/pdd/goods';

export default {
  components: { commonDialog },
  data() {
    return {
      data: { type: 0, stockNum: null },
      rules: { stockNum: [{ required: true, message: '数值不能为空' }] },
      details: [],
    }
  },
  methods: {
    openEdit(rows) {
      this.details = [];
      rows.forEach(function (_data) {
        (_data.skuList || []).forEach(function (sku) {
          this.details.push({ goodsId: _data.goodsId, sku_id: sku.sku_id });
        }, this);
      }, this);
      this.$refs.dialog.openEdit({ ...this.data });
    },
    saveFunc() {
      var self = this;
      return new Promise(function (resolve, reject) {
        var saveData = {
          skuList: self.details.map(function (x) {
            var item = {
              goodsId: x.goodsId,
              skuId: x.sku_id,
              quantity: 0,
              updateType: 1,
            };
            switch (self.data.type) {
              case 0:
                item.updateType = 1;
                item.quantity = self.data.stockNum;
                break;
              case 1:
                item.updateType = 2;
                item.quantity = self.data.stockNum;
                break;
              case 2:
                item.updateType = 2;
                item.quantity = self.data.stockNum * -1;
                break;
            }
            return item;
          })
        };
        goodsApi.stock(saveData).then(function (res) {
          if (res.data && res.data.length > 0) {
            var html = '';
            res.data.forEach(function (x) { html += '<div>' + x.title + '：' + x.errorMsg + '</div>' });
            self.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
            reject({});
          } else {
            resolve({ Code: 0 });
          }
        }).catch(function (err) { reject(err); });
      });
    },
    onClosed() {

    },
  }
}
</script>
